import React, { useEffect } from "react";

import FASTable from "../../../../../components/Tables/FASTable";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import { Loader } from "../../../../../components/Loader/Loader";
import {
  SupplierProItemQty,
  SupplierProItemQtyFun,
} from "../../../../../Redux/Slice/Fas/Profile Analysis/Supplier/SupplierSlice";
import { CustomerSupplierProAcDetail } from "../../../../../Redux/Slice/Fas/Profile Analysis/Customer/CustomerSlice";

export default function MonthlyItemsQTY({
  accountName,
  accountGroup,
  startDate,
  endDate,
}) {
  const dispatch = useDispatch();

  const { Colourdata } = useSelector((state) => state.ClientLogin);
  const { SupplierItemQtydata } = useSelector((state) => state.SupplierSlice);

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWFAS");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWFASDARK",
  );

  const isdark = Cookies.get("theme") || "light";
  const Firm = Cookies.get("Firm");
  const YearId = Cookies.get("FinancialYear");

  useEffect(() => {
    dispatch(SupplierProItemQtyFun());
    dispatch(
      SupplierProItemQty({
        Firm,
        Year: YearId,
        AcIDs: accountName.join(","),
        selectedIds: accountGroup.join(","),
        startDate: startDate,
        endDate: endDate,
      }),
    );
    dispatch(CustomerSupplierProAcDetail({ AcIDs: accountName }));
  }, [dispatch, Firm, YearId, accountName]);

  const getRows = SupplierItemQtydata?.Detail?.map((label, index) => ({
    chart: true,
    ItemName: label.ItemName,
    AprQty: label.AprQty,
    MayQty: label.MayQty,
    JunQty: label.JunQty,
    JulQty: label.JulQty,
    AugQty: label.AugQty,
    SepQty: label.SepQty,
    OctQty: label.OctQty,
    NovQty: label.NovQty,
    DecQty: label.DecQty,
    JanQty: label.JanQty,
    FebQty: label.FebQty,
    MarQty: label.MarQty,
    Qty: label.Qty,
  }));

  const getColumns = [
    { label: "Chart", key: "charts", align: "center" },
    { label: "Sr. No.", key: "srNumber", align: "center" },
    {
      label: "Item Name",
      key: "ItemName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Total Qty", key: "Qty", format: "true", align: "right" },
    { label: "Apr", key: "AprQty", format: "true", align: "right" },
    { label: "May", key: "MayQty", format: "true", align: "right" },
    { label: "Jun", key: "JunQty", format: "true", align: "right" },
    { label: "Jul", key: "JulQty", format: "true", align: "right" },
    { label: "Aug", key: "AugQty", format: "true", align: "right" },
    { label: "Sep", key: "SepQty", format: "true", align: "right" },
    { label: "Oct", key: "OctQty", format: "true", align: "right" },
    { label: "Nov", key: "NovQty", format: "true", align: "right" },
    { label: "Dec", key: "DecQty", format: "true", align: "right" },
    { label: "Jan", key: "JanQty", format: "true", align: "right" },
    { label: "Feb", key: "FebQty", format: "true", align: "right" },
    { label: "Mar", key: "MarQty", format: "true", align: "right" },
  ];

  if (SupplierItemQtydata === "no" || SupplierItemQtydata === null) {
    return (
      <div className="flex justify-center items-center h-screen text-xl text-[#502000]">
        <Loader />
      </div>
    );
  }

  return (
    <div style={{ marginTop: "20px" }}>
      <div
        style={{
          borderRadius: "12px",
          overflow: "hidden",
          boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
        }}
      >
        <div
          style={{
            backgroundColor:
              isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour4,
            color:
              isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour11,
            padding: "14px",
            margin: 0,
          }}
        >
          <h2
            style={{
              fontSize: "18px",
              margin: 0,
              letterSpacing: "1px",
              fontWeight: "600",
            }}
          >
            MONTHLY ITEM QTY
          </h2>
        </div>
        <FASTable data={getRows} columns={getColumns} />
      </div>
    </div>
  );
}
